import { toGqlId } from "@src/api/formatters/shopify";
import { ProductPickerThunkParams } from "@src/components/targeting/components/expressions/context";
import { createAsyncThunk } from "@src/store/createAsyncThunk";
import {
  openProductPicker,
  setProductPickerProducts,
  setProductPickerSelectedProducts,
} from "@src/store/slices/productPicker";
import {
  ProductPickerProduct,
  ProductPickerSelectedProduct,
} from "@src/store/slices/productPicker/types";
import { getUpsellProductRuleActionExpressionList } from "@src/store/slices/upsellProductRules/selectors";

export const openUpsellActionProductPicker = createAsyncThunk<
  void,
  ProductPickerThunkParams
>(
  "productPicker/openUpsellActionProductPicker",
  (params, { dispatch, getState }) => {
    const {
      selectedProductIds,
      expressionsIndex,
      targetingId,
      checkoutBlockId,
    } = params;

    const ruleId = targetingId;

    if (!ruleId || !checkoutBlockId) {
      return;
    }

    dispatch(
      openProductPicker({
        type: "checkoutUpsellProductAction",
        checkoutBlockId,
        targetingId: ruleId,
        expressionsIndex,
      })
    );

    if (selectedProductIds === "") {
      dispatch(setProductPickerSelectedProducts([]));
      return;
    }

    const expressionsList =
      getUpsellProductRuleActionExpressionList(ruleId)(getState());
    const originalQuery = expressionsList[0]?.queries[expressionsIndex];

    const items = Array.isArray(originalQuery?.value)
      ? originalQuery.value
      : [];

    const formattedProductIds: string[] = selectedProductIds.split(",");

    const products: ProductPickerProduct[] = items.map((item) => ({
      id: item.productId,
      title: item.productTitle,
      image: item.productImage ?? undefined,
      handle: "",
      requiresSellingPlan: undefined,
      hasVariantsThatRequiresComponents: false,
      sellingPlanGroupCount: 0,
      options: item.options,
      variants: item.variants.map((v) => ({
        id: toGqlId(v.variantId, "ProductVariant"),
        title: v.variantTitle,
        price: v.price,
        compareAtPrice: v.compareAtPrice ?? null,
        availableForSale: true,
        selectedOptions: v.variantOptions ?? [],
      })),
    }));

    dispatch(setProductPickerProducts(products));

    const selectedProducts: ProductPickerSelectedProduct[] =
      formattedProductIds.map((productId) => {
        const foundProductDisplay = originalQuery?.displayData?.[productId];

        const item = items.find((i) => i.productId === productId);

        const includedVariants = item?.variants.filter(
          (v) => v.inclusionType === "include"
        );
        const totalVariantCount = item?.variants.length;

        const selectedVariantIds =
          includedVariants &&
          totalVariantCount &&
          includedVariants.length === totalVariantCount
            ? undefined
            : includedVariants?.map((v) =>
                toGqlId(v.variantId, "ProductVariant")
              );

        return {
          id: productId,
          title: foundProductDisplay?.title || "",
          image: foundProductDisplay?.image || undefined,
          handle: "",
          requiresSellingPlan: false,
          selectedVariantIds,
          totalVariantCount,
        };
      });

    dispatch(setProductPickerSelectedProducts(selectedProducts));
  }
);
